<template src="./dimension.html"></template>

<script lang="ts">
import domUtils from 'util/dom-utils'
import { hostsConfig } from 'init/config'
import { localizedNumber } from 'util/localization-utils'

export default {
  data() { return { dotSize: 0 } },
  props: {
    type: { type: Number },
    label: { type: String },
    value: { type: Number },
    valueLabels: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    imageUrls() {
      // TODO: just use value labels?  Or separate prop?
      if (this.isSelectImage) {
        return this.valueLabels.map((imageId) => {
          return `${hostsConfig.protocol}://${hostsConfig.imageStoreBase}/custom-dim/${hostsConfig.siteKey}/${imageId}.png`
        })
      }
      return []
    },
    isRange() {
      return this.type === 2
    },
    isRating() {
      return this.type === 1
    },
    isSelectImage() {
      return this.type === 5
    },
    valueLabel() {
      if (this.isRating) {
        return `${localizedNumber(this.value)} / ${localizedNumber(5.0)}`
      } else if (this.isRange) {
        // for range, 'value' is the sort order which is actually the index of one of the
        // value labels
        return this.valueLabels[this.value]
      } else if (!this.isSelectImage) {
        return this.valueLabels.length > 0 ? this.valueLabels.join(', ') : ''
      }
      return ''
    },
    valuePercentage() {
      if (this.isRange) {
        const percentage = this.value / (this.valueLabels.length - 1)
        const dotAdjustment = Math.round(this.dotSize * percentage)
        return `calc(${(percentage * 100).toFixed(1)}% - ${dotAdjustment}px)`
      } else if (this.isRating) {
        return `${(this.value / 5.0 * 100).toFixed(1)}%`
      }
      return ''
    }
  },
  mounted() {
    if (this.isRange) {
      domUtils.whenRefIsVisible(this.$refs, 'dot').then(() => {
        this.dotSize = this.$refs.dot.offsetWidth
      }).catch(() => {
        // when initially hidden on page (e.g. under a tab), offsetWidth is 0.  This is a fallback
        // to the px equivalent to the rem(10) it is set to in css
        this.dotSize = 10
      })
    }
  }
}
</script>

<style lang="scss" src="./dimension.scss"></style>
